module.exports = __webpack_public_path__ + "img/chevron_right.e0020084.svg";